import classNames from 'classnames';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputFormField from './input-form-field';

class NumberFormField extends Component {

  incrementValue(value) {
    const {
      max,
      step
    } = this.props;

    return value >= max ?
      value :
      value + step;
  }

  decrementValue(value) {
    const {
      min,
      step
    } = this.props;

    return value <= min ?
      value :
      value - step;
  }

  clampValue(value) {
    const {
      max,
      min
    } = this.props;

    return fp.clamp(min, max, value);
  }

  onValueChange(value, transform) {
    const {
      name,
      value: propsValue
    } = this.props;
    const parsedValue = parseFloat(value);

    this.props.onChange({
      name,
      value: transform.bind(this)(isNaN(parsedValue) ?
        propsValue :
        parsedValue),
      text: value
    });
  }

  repeat(transform) {
    this.repeatInterval = setInterval(() => this.onValueChange(null, transform), this.props.repeatTimeout);
  }

  onMouseDown(transform) {
    // Make the change once (to approximate a normal button press).
    this.onValueChange(null, transform);
    // Then wait a little bit before kicking in with the repeat.
    this.initialDelayTimeout = setTimeout(() => this.repeat(transform), this.props.repeatTimeout);
  }

  onMouseUp() {
    clearTimeout(this.initialDelayTimeout);
    clearInterval(this.repeatInterval);
  }

  render() {
    const {
      formFieldProps,
      id,
      inputProps,
      label,
      large,
      max,
      maxLength,
      min,
      required,
      size,
      step,
      validation,
      value,
      disabled,
      quantityDials
    } = this.props;

    const formItemProps = formFieldProps && formFieldProps.formItemProps;

    const inputFormFieldProps = {
      id,
      inputType: 'number',
      value,
      onChange: (e) => this.onValueChange(e.target.value, this.clampValue),
      onBlur: (e) => this.onValueChange(e.target.value, this.clampValue),
      required,
      label,
      validation,
      inputProps,
      formFieldProps: {
        ...formFieldProps,
        type: quantityDials ? 'number-spinner' : 'number-spinner number-entry',
        formItemProps: {
          ...formItemProps,
          className: classNames(formItemProps && formItemProps.className, { large })
        },
        disabled: disabled
      },
      step: step,
      min: min,
      max: max,
      size: size,
      disabled: disabled,
      maxLength: maxLength
    };

    return (
      <InputFormField {...inputFormFieldProps}>
        {!disabled && quantityDials ?
          <div className='quantity-nav'>
            <div className='quantity-button quantity-up' onMouseDown={(e) => this.onMouseDown(this.incrementValue)} onMouseUp={(e) => this.onMouseUp()} onMouseOut={(e) => this.onMouseUp()}>+</div>
            <div className='quantity-button quantity-down' onMouseDown={(e) => this.onMouseDown(this.decrementValue)} onMouseUp={(e) => this.onMouseUp()} onMouseOut={(e) => this.onMouseUp()}>-</div>
          </div> : null
        }
      </InputFormField>
    );
  }
}

NumberFormField.propTypes = {
  formFieldProps: PropTypes.object,
  id: InputFormField.propTypes.id,
  inputProps: InputFormField.propTypes.inputProps,
  label: InputFormField.propTypes.label,
  large: PropTypes.bool,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  repeatTimeout: PropTypes.number,
  required: InputFormField.propTypes.required,
  size: PropTypes.number,
  step: PropTypes.number,
  validation: InputFormField.propTypes.validation,
  value: InputFormField.propTypes.value,
  disabled: PropTypes.bool,
  quantityDials: PropTypes.bool
};

NumberFormField.defaultProps = {
  max: 9999,
  maxLength: 4,
  min: 1,
  repeatTimeout: 100,
  size: 4,
  step: 1,
  quantityDials: true
};

export default NumberFormField;



// WEBPACK FOOTER //
// ./src/containers/components/number-form-field.js